<template>
  <div class="step-a-wrapper">
    <div><h3 class="mb-20" style="color: #1890ff;">Section 3: Applied and Working (Unemployed)</h3></div>
    <a-form layout="vertical" :form="formStepC">
      <!-- Q18 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold" style="">18. If unemployed, please specify the most significant reasons</span> 
        </template>
        <a-select 
          v-model="form.unemployedReason" 
          show-search 
          placeholder="Select..." 
          v-decorator="[
            'form.unemployedReason',
            { rules: [{ required: true, message: 'Please input' }] },
          ]"
        >
          <a-select-option value="1">(1) Don’t want to work now</a-select-option>
          <a-select-option value="2">(2) Waiting for the application’s result</a-select-option>
          <a-select-option value="3">(3) Could not find a job</a-select-option>
          <a-select-option value="4">(4) Willing to be a freelancer</a-select-option>
          <a-select-option value="0">(0) Others </a-select-option>
        </a-select>
        <a-input class="mt-20" v-if="form.unemployedReason === '0'" v-model="form.unemployedReasonOther" />
      </a-form-item>

      <!-- Q19 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold" style="">19. Do you have any problem in getting a job ?</span> 
        </template>
        <a-radio-group 
          v-model="form.hasJobProblem"
          v-decorator="[
            'form.hasJobProblem',
            {
              initialValue: form.hasJobProblem,
              rules: [
                { required: true, message: 'Please select' }
              ]
            }
          ]"
        >
          <a-radio value="02">Yes</a-radio>
          <a-radio value="01">No</a-radio>
        </a-radio-group>

        <div v-if="form.hasJobProblem === '02'" style="margin-top: 16px;">
          <a-form-item>
            <template slot="label">
              <span class="font-web font-weight-bold" style="">If yes, please specify. (You can choose more than 1 item)</span> 
            </template>
            <a-checkbox-group 
              class="mt-10"
              v-model="form.jobProblemDetails"
              v-decorator="[
                'form.jobProblemDetails',
                {
                  initialValue: form.jobProblemDetails,
                  rules: [
                    { required: true, type: 'array', min: 1, message: 'Please select You can choose more than 1 item', trigger: 'change' }
                  ]
                }
              ]"
            >
              <a-row :gutter="[16,16]">
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="02">(02) Lack information on job availability</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="03">(03) Could not find a desired job</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="04">(04) Don’t want to take an examination</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="05">(05) Lack personal support</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="06">(06) Lack personal or financial guarantors</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="07">(07) Rejected by an organization</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="08">(08) Little salary</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="09">(09) Could not pass an examination</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="10">(10) Health issues</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="11">(11) Lack of foreign language skill</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="12">(12) Lack of computer skill</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="13">(13) Lack of experience</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="14">(14) GPA does not meet the requirement</a-checkbox></a-col>
                <a-col :sm="24" :xs="24" :md="12" ><a-checkbox value="00">(00) Others</a-checkbox></a-col>
              </a-row>
            </a-checkbox-group>
          </a-form-item>
          <a-input class="mt-5" v-if="form.jobProblemDetails.includes('00')" v-model="form.jobProblemOther" />
        </div>
      </a-form-item>

      <!-- Q20 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold" style="">20. Do you prefer to work in Thailand or oversea ?</span> 
        </template>
        <a-radio-group 
          class="radio-group-wrap"
          v-model="form.workLocation"
        >
          <a-radio class="radio-text" value="01">(01) Thailand</a-radio>
          <a-radio class="radio-text" value="02">(02) Oversea: <a-input v-model="form.overseaLocation" style="width: 300px; display: inline-block; margin-left: 10px;" /></a-radio>
        </a-radio-group>
      </a-form-item>

      <!-- Q21 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold" style="">21. What is your preference position ?</span> 
        </template>
        <a-input 
          v-model="form.preferencePosition" 
          v-decorator="[
            'form.preferencePosition',
            {
              initialValue: form.preferencePosition,
              rules: [{ required: true, message: 'Please input' }] 
            },
          ]"
        />
      </a-form-item>

      <!-- Q22 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold" style="">22. What is your skills or curriculum that you want to improve ?</span> 
        </template>
        <a-input 
          v-model="form.skillsToImprove" 
          v-decorator="[
            'form.skillsToImprove',
            {
              initialValue: form.skillsToImprove,
              rules: [{ required: true, message: 'Please input' }] 
            },
          ]"
        />
      </a-form-item>

      <!-- Q23 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold">
            23. Are you willing to reveal this information for employers/organization to applying a job?
          </span>
        </template>

        <a-radio-group 
          v-model="form.revealInfo" 
          class="radio-group-wrap"
          v-decorator="[
            'form.revealInfo',
            {
              initialValue: form.revealInfo,
              rules: [{ required: true, message: 'Please input' }] 
            },
          ]"
        >
          <a-radio value="0"><span class="radio-text">(0) No, I am not willing to reveal any information.</span></a-radio>
          <a-radio value="1"><span class="radio-text">(1) I am willing to reveal the information for all employers.</span></a-radio>
          <a-radio value="2"><span class="radio-text">(2) I am willing to reveal the information for all employers except in workforce industry.</span></a-radio>
          <a-radio value="3"><span class="radio-text">(3) I am willing to reveal the information for all employers except in insurance and direct sale industry.</span></a-radio>
          <a-radio value="4"><span class="radio-text">(4) I am willing to reveal the information for all employers except in workforce, insurance and direct sale industry.</span></a-radio>
        </a-radio-group>
      </a-form-item>

      <!-- Q24 -->
      <a-form-item>
        <template slot="label">
          <span class="font-web font-weight-bold" style="">24. Do you want to continue study ?</span> 
        </template>
        <a-radio-group @change="handleContinueStudyChange"  
          v-decorator="[
            'form.continueStudy',
            {
              initialValue: form.continueStudy,
              rules: [{ required: true, message: 'Please input' }] 
            },
          ]"
        >
          <a-radio value="1">(1) Yes</a-radio>
          <a-radio value="2">(2) No (go to section 5)</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>

    <div class="text-right">
      <a-button-group>
        <a-button @click="backSection" type="primary"> <a-icon type="left" />Go back </a-button>
        <a-button @click="submitAndValidateC" type="primary"> Go forward<a-icon type="right" /> </a-button>
      </a-button-group>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formStepC: this.$form.createForm(this, { name: 'stepC' }),
      radioStyleStepC: {
        width: '30px',
        lineHeight: '30px',
      },
      form: {
        unemployedReason: '',
        unemployedReasonOther: '',
        hasJobProblem: '',
        jobProblemDetails: [],
        jobProblemOther: '',
        workLocation: '',
        overseaLocation: '',
        preferencePosition: '',
        skillsToImprove: '',
        revealInfo: '',
        continueStudy: ''
      }
    };
  },
  mounted() {},
  methods: {
    handleContinueStudyChange(e) {
      const val = e.target.value;
      this.form.continueStudy = val;
      this.formStepC.validateFields((err, values) => {
        if (!err) {
          this.$emit('updateData', 'stepC', { ...this.form, ...values.form, continueStudy: val });
          if (val === '1') setTimeout(() => { this.$emit('NextSectionSkip', 3); }, 400);
          else if (val === '2') setTimeout(() => { this.$emit('NextSectionSkip', 4); }, 400);
        }
      });
    },
    backSection() {
      this.$emit('backSection')
    },
    submitAndValidateC() {
      this.formStepC.validateFields((err, values) => {
        if (!err) {
          const continueStudy = this.form.continueStudy;
          if (continueStudy === '1') {
            this.$emit('updateData', 'stepC', { ...this.form, ...values.form, continueStudy: continueStudy });
            setTimeout(() => { this.$emit('NextSectionSkip', 3); }, 400); // Section 4 / stepD
          } else {
            this.$emit('updateData', 'stepC', { ...this.form, ...values.form, continueStudy: continueStudy });
            setTimeout(() => { this.$emit('NextSectionSkip', 4); }, 400); // Section 5 / stepE
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.step-a-wrapper {
  padding: 20px;
}

.radio-group-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 100%;
}

.radio-group-wrap .radio-text {
  display: inline-block;
  max-width: 100%;
  white-space: normal;      /* อนุญาตให้ขึ้นบรรทัดใหม่ */
  word-break: break-word;   /* ตัดคำถ้าจำเป็น */
  line-height: 1.4;
}
</style>
